












import { defineComponent, computed } from '@vue/composition-api';
// import { Message, AutomationData } from '../../dataType';
import { useLocale } from '../../hooks/useLocale';
import { useAsideComponent } from '../../hooks/useAsideComponent';

export default defineComponent({
  setup() {
    const { t } = useLocale();
    const { message, setAsideStatus } = useAsideComponent();
    console.log(message, 'message');
    const rule = computed(() => {
      return (message.value.content.rule || []);
    });
    const projectId = computed(() => rule.value.projectId);
    const ruleId = computed(() => rule.value.ruleId);
    // const { sendMessage } = useConfig();
    // const { setAutomationProject, getAutomationProject } = useAutomationConfig();
    const handlerCancel = () => {
      setAsideStatus(false);
    };
    const handlerSubmit = () => {
      setAsideStatus(false);
    };

    return {
      t,
      rule,
      projectId,
      ruleId,
      handlerCancel,
      handlerSubmit
    };
  }
});
